module.exports = __webpack_public_path__ + "static/media/uc.c940db16.png";


//////////////////
// WEBPACK FOOTER
// ./src/core/assets/uc.png
// module id = 1357
// module chunks = 0